import { useEffect, useState } from "react";
import { DistrictModel } from "../../../models/district.model";
import provinceData from "../../../data/lao_province.json";
import { ProvinceModel } from "../../../models/province.model";

const dataProvinceFromJson: ProvinceModel[] = provinceData;

const useProfileDetailController = () => {
  const [provinceValue, setProvinceValue] = useState<string>(null!);
  const [districtsValue, setDistrictsValue] = useState<string>(null!);
  const [districtsData, setDistrictsData] = useState<DistrictModel[]>([]);

  const [imageToShow, setImageToShow] = useState<any>(null!);
  const [imageFile, setImageFile] = useState<File | null>(null);

  const handleGetProfile = async () => {
    try {
    } catch (err: any) {
      console.log(err);
    }
  };

  const handleSelectedImage = (e: any) => {
    const file = e.target.files[0];
    setImageFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImageToShow(reader.result);
      }
    };
    reader.readAsDataURL(file);
    setImageToShow(file);
  };

  useEffect(() => {
    if (provinceValue) {
      const districtData = dataProvinceFromJson.filter(
        (item) => item?.provinceNameLA === provinceValue
      )[0]?.districts;

      if (districtData?.length > 0) {
        setDistrictsData(districtData);
        setDistrictsValue(districtData[0]?.districtNameLA);
      } else {
        setDistrictsData(districtData);
        setDistrictsValue(null!);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provinceValue]);

  useEffect(() => {
    handleGetProfile();
  }, []);

  return {
    districtsData,
    districtsValue,
    provinceValue,
    handleSelectedProvince: (e: any) => setProvinceValue(e.target.value),
    handleSelectedDistrict: (e: any) => setDistrictsValue(e.target.value),
    provinceData,
    handleSelectedImage,
    imageToShow,
  };
};
export default useProfileDetailController;
